import { CompanyFilter } from "../../../legacy/types/companyFilter";

/**
 * Transforms SAM geography configuration to CompanyFilter geography format
 *
 * @param geography SAM geography configuration
 * @param baseFilters Base filters to update with geography data
 * @returns Updated filters with geography data
 */
export const transformSamGeography = (
  geography: {
    regionsIds?: string[];
    countryIds?: string[];
    stateIds?: string[];
    excludedCountryIds?: string[];
  },
  baseFilters: CompanyFilter
): CompanyFilter => {
  const result = { ...baseFilters };

  if (geography.countryIds?.length) {
    result.countryAlpha2s = geography.countryIds;
  }

  if (geography.regionsIds?.length) {
    result.regionNames = geography.regionsIds;
  }

  if (geography.stateIds?.length) {
    result.stateIds = geography.stateIds;
  }

  if (geography.excludedCountryIds?.length) {
    result.excludedCountryAlpha2s = geography.excludedCountryIds;
  }

  return result;
};
